/**
 * Run npx tsx scripts/auditLogs/addTableNamesToAuditLogs.ts to generate translation keys for audit
 * logs.
 */
export const tableNames = [
  "networks",
  "store_formats",
  "provinces",
  "services_and_goods",
  "stores",
  "store_groups",
  "clients",
  "stores_2_store_groups",
  "updates_departments",
  "project_periods",
  "stores_2_projects",
  "stores_2_project_periods",
  "shifts",
  "shift_report_departments",
  "shift_reports",
  "shift_report_department_entries",
  "project_types",
  "limits",
  "project_roles",
  "invoicing_companies",
  "schedules",
  "default_rates",
  "projects",
  "payroll_departments",
  "users",
  "department_based_assignments",
  "role_based_assignments",
  "department_based_project_rates",
  "timesheet_entries",
  "role_based_project_rates",
  "payroll_types",
  "project_settlement_comments",
  "contractor_visits",
  "invoice_specifications",
  "invoice_specification_costs",
  "invoice_specification_stores",
  "system_roles",
  "system_permissions",
  "role_permissions",
  "structure_assignments",
  "default_store_project_assignees",
  "stores_2_projects_assignees",
  "project_managers",
  "questionnaires",
  "contractors",
  "agreement_types",
  "disability_certificates",
  "citizenships",
  "tax_offices",
  "agreement_companies",
  "payroll_department_based_inspection",
  "payrolls",
  "contractor_tax_status_history",
  "payroll_aggregation",
  "agreement_questionnaires",
  "agreements",
  "payroll_role_based_inspection",
  "payroll_split",
  "agreement_status_history",
  "contractor_cards",
  "agreement_tokens",
  "agreement_comments",
  "agreement_paper_scans",
  "agreement_file_downloads",
  "app_settings",
  "contractor_planned_hours_approvals",
  "project_comments",
  "audit_logs",
  "schema_history",
];
